import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/NumberAndPlace/NumberAndPlaceLevel.png";
import PracticeGame from "../../components/MP_PracticeGame";
import Calculator from "../../components/Calculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { MultiHook } from "tapable";
import { Textfit } from 'react-textfit';
import Emile1 from "../../assets/NumberSense/Images/emile1.png";
import Emile2 from "../../assets/NumberSense/Images/emile2.png";
import Emile3 from "../../assets/NumberSense/Images/emile3.png";
import Emile4 from "../../assets/NumberSense/Images/emile4.png";
import Emile5 from "../../assets/NumberSense/Images/emile5.png";
import aimee1 from "../../assets/NumberSense/Images/aimee1.png";
import aimee2 from "../../assets/NumberSense/Images/aimee2.png";
import aimee3 from "../../assets/NumberSense/Images/aimee3.png";
import aimee4 from "../../assets/NumberSense/Images/aimee4.png";
import aimee5 from "../../assets/NumberSense/Images/aimee5.png";
import rocket1 from "../../assets/NumberSense/Images/rocket1.png";
import rocket2 from "../../assets/NumberSense/Images/rocket2.png";
import rocket3 from "../../assets/NumberSense/Images/rocket3.png";
import rocket4 from "../../assets/NumberSense/Images/rocket4.png";
import rocket5 from "../../assets/NumberSense/Images/rocket5.png";
import scrambler1 from "../../assets/NumberSense/Images/scrambler1.png";
import scrambler2 from "../../assets/NumberSense/Images/scrambler2.png";
import scrambler3 from "../../assets/NumberSense/Images/scrambler3.png";
import scrambler4 from "../../assets/NumberSense/Images/scrambler4.png";
import scrambler5 from "../../assets/NumberSense/Images/scrambler5.png";
import triangle1 from "../../assets/NumberSense/Images/triangle1.png";
import triangle2 from "../../assets/NumberSense/Images/triangle2.png";
import triangle3 from "../../assets/NumberSense/Images/triangle3.png";
import triangle4 from "../../assets/NumberSense/Images/triangle4.png";
import triangle5 from "../../assets/NumberSense/Images/triangle5.png";
import rectangle1 from "../../assets/NumberSense/Images/rectangle1.png";
import rectangle2 from "../../assets/NumberSense/Images/rectangle2.png";
import rectangle3 from "../../assets/NumberSense/Images/rectangle3.png";
import rectangle4 from "../../assets/NumberSense/Images/rectangle4.png";
import rectangle5 from "../../assets/NumberSense/Images/rectangle5.png";
import Table from "../../assets/NumberSense/Images/tableratios.png";


function ReturnRatioImage(image, number) {
  if (image == "Emile") {
    if (number == 1) {
      return Emile1;
    }
    if (number == 2) {
      return Emile2;
    }
    if (number == 3) {
      return Emile3;
    }
    if (number == 4) {
      return Emile4
    }
    if (number == 5) {
      return Emile5
    }
  }
  if (image == "Aimee") {
    if (number == 1) {
      return aimee1;
    }
    if (number == 2) {
      return aimee2;
    }
    if (number == 3) {
      return aimee3;
    }
    if (number == 4) {
      return aimee4
    }
    if (number == 5) {
      return aimee5
    }
  }
  if (image == "Triangle") {
    if (number == 1) {
      return triangle1;
    }
    if (number == 2) {
      return triangle2;
    }
    if (number == 3) {
      return triangle3;
    }
    if (number == 4) {
      return triangle4
    }
    if (number == 5) {
      return triangle5
    }
  }
  if (image == "Scrambler") {
    if (number == 1) {
      return scrambler1;
    }
    if (number == 2) {
      return scrambler2;
    }
    if (number == 3) {
      return scrambler3;
    }
    if (number == 4) {
      return scrambler4
    }
    if (number == 5) {
      return scrambler5
    }
  }
  if (image == "Rectangle") {
    if (number == 1) {
      return rectangle1;
    }
    if (number == 2) {
      return rectangle2;
    }
    if (number == 3) {
      return rectangle3;
    }
    if (number == 4) {
      return rectangle4
    }
    if (number == 5) {
      return rectangle5
    }
  }
  if (image == "Rocket") {
    if (number == 1) {
      return rocket1;
    }
    if (number == 2) {
      return rocket2;
    }
    if (number == 3) {
      return rocket3;
    }
    if (number == 4) {
      return rocket4
    }
    if (number == 5) {
      return rocket5
    }
  }
}

var image;

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}


//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}


function GenQuestion(q) {
  console.log(q.right_answer);
  //All the shared variables
  let questionAnswers = [];
  //Add the correct answer
  questionAnswers.push({ correct: true, value: q.right_answer });
  //Add the wrong answers
  questionAnswers.push({ correct: false, value: q.wrong_answer_1 });
  questionAnswers.push({ correct: false, value: q.wrong_answer_2 });
  questionAnswers.push({ correct: false, value: q.wrong_answer_3 });
  var html;

  //question html if topic = Ratio1
  if (q.topic_key == "Ratio1") {
    var images = q.images.split(":");
    var amounts = q.right_answer.split(":");
    html = '<img src="' + ReturnRatioImage(images[0], parseInt(amounts[0])) + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
    html += '<img src="' + ReturnRatioImage(images[1], parseInt(amounts[1])) + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
  }
  if (q.topic_key == "Ratio3") {
    var table = q.images.split(",");
    table[0] = table[0].replace("Table of ", "");
    html = '<img src="' + Table + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:34% ; right:51.5%'>" + table[0] + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:63% ; right:51.5%'>" + table[1] + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:34% ; right:15%'>" + table[2] + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:63% ; right:15%'>" + table[3] + "</b>";
  }

  shuffleArray(questionAnswers);
  console.log(q.question_line_2);
  let questionObj = {
    question: q.question_line_1,
    question2: q.question_line_2,
    answers: questionAnswers,
    topic_id: q.topic_id,
    questionHTML: html
  };
  return questionObj;
}


var hideImageStart = false;
var oldQuestion = undefined;

export default function Multiplayer({ ...props }) {
  const game = props.game;
  console.log(props);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([,]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  //const [realQuestions, setRealQuestions] = useState();
  const [workAround, setWorkAround] = useState(false);
  const [place, setPlace] = useState(0);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(-10);

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else if (waitTime != -10) {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      //correct answer
      if (value.correct == true) {
        setCorrectQuestions([...correctQuestions, currentQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);
        if (multiplier != 0 && multiplier != undefined)
          props.SubmitScore(multiplier * 10);


        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
          props.SubmitScore(-10)
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }

      //Generates a new question
      //newQuestion();

    }
  }

  function GetListOfPositions() {
    //order the scores
    //console.log(props);
    //var web = props.parent.getwebrtc();
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    // console.log(webcopy);
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    //console.log(webcopy);
    //replace yourname with YOU
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username)
        webcopy[i].username = "You"
    }
    var scoreText = [];
    for (let i = 0; i < webcopy.length; i++) {
      let temptext = webcopy[i].username + ": " + webcopy[i].score
      scoreText.push(temptext);
    }
    // console.log(scoreText);
    const listItems = scoreText.map((i) =>
      <li>{i}</li>
    );

    return listItems;
  }

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    var difficulty = Math.floor(Math.random() * questions.length);
    var questionNum = Math.floor(Math.random() * questions[difficulty].length)
    currQuestion = GenQuestion(questions[difficulty][questionNum]);;
    console.log(questions[difficulty][questionNum])
    console.log(currQuestion);
    setCurrentQuestion(currQuestion);
    NewImage();
    return currQuestion;
  }

  var hideImage = false;


  var DelayImage = function (delay) {
    console.log("Hide image start:" + hideImageStart);
    console.log("Hide image:" + hideImage);
    if (hideImageStart == false) {
      hideImageStart = true;
      hideImage = false;
      console.log("Displaying image for " + delay);
      setTimeout(HideImage, delay * 1000);
    }
  }

  function HideImage() {
    hideImageStart = false;
    hideImage = true;
    image = require('../../assets/NumberSense/Images/Empty.png');
  }


  function NewImage() {
    if (currQuestion.image != undefined) {
      console.log(oldQuestion);
      console.log(currQuestion);
      oldQuestion = currQuestion;
      var currImage = currQuestion.image;
      var correctAnswerName;
      //gets correct answer name for testing
      for (let i = 0; i < currQuestion.answers.length; i++) {
        if (currQuestion.answers[i].correct == true)
          correctAnswerName = currQuestion.answers[i].value;
      }
      image = require('../../assets/NumberSense/Images/' + currImage);
      //console.log(oldQuestion);
      //console.log(currentQuestion);
      //console.log(currentQuestion.time);
      if (hideImageStart == false && currQuestion.time != "") {
        //start timer thing if timer is a thing
        console.log("do delay thing");
        DelayImage(parseInt(currQuestion.time));
      }
    }
  }

  function GetPlace() {
    var position = 0;
    //order the scores
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    console.log(webcopy);
    //gets your position in the list
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username) {
        setPlace(i + 1);
        position = i + 1;
      }

    }
    console.log(place);
    console.log(position);
    return position;
  }

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions)
      setCurrentQuestion(newQuestion())
    }
  }, [questions]);

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
      comboNum = 4;
    //var imageName = props.gameData.animation_path + "/combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    //console.log("../../assets/" + imageName)

    return (require("../../assets/Ratios/" + "RatiosLevel.png"))

  }


  return (
    <PracticeGame
      parent={props}
      loading={!questions}
      correct={correctQuestions}
      incorrect={incorrectQuestions}
      score={score}
      onBack={() => props.onBack()}
      defaultTimer={60}
      restart={() => {
        setCombo(0);
        setScore(0);
        setCorrectQuestions([]);
        setIncorrectQuestions([]);
      }}
      feedback={feedback}
      homework_id={props.homework_id}
      getplace={() => GetPlace()}
    >
      <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
        <Body>
          <FormContent style={{ right: "100px", top: "0px", width: "200px", height: "50%" }}>
            <br></br>
            {GetListOfPositions()}
          </FormContent>
          <div>{currQuestion !== undefined ? (


            <Container>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Question
                  type="text"
                  disabled
                  value={
                    currQuestion.question !== undefined
                      ? currQuestion.question.replace("$", "?")
                      : ""
                  }
                ><Textfit mode="single" style={{ height: "80%" }} > {currQuestion.question}</Textfit></Question>
              </div>
              {currentQuestion.question2 !== undefined && currentQuestion.question2 !== "" ?
                        <Question
                          type="text"
                          disabled
                          value={
                            currentQuestion.question2 !== undefined
                              ? currentQuestion.question2.replace("$", "?")
                              : ""
                          }
                        ><Textfit mode="multi" max="40" style={{ height: "100%" }}><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question2) }} />}</span></Textfit></Question>
                        : ""}


              <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
                {currQuestion.questionHTML != "" ? (
                  <DynamicStyle>
                    <div dangerouslySetInnerHTML={{ __html: currQuestion.questionHTML }}></div>
                  </DynamicStyle>
                ) :
                  (
                    <div></div>
                  )}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between"
                }}
              >
                {showColouredFeedback == false && currQuestion.answers !== undefined &&
                  currQuestion.answers.map(answer => (
                    <Button
                      value={<div dangerouslySetInnerHTML={answer.value} />}
                      style={{ flex: 1, margin: "20px" }}
                      onClick={() => checkResult(answer, true)}
                    >
                      <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                    </Button>
                  ))}

                {showColouredFeedback == true && currQuestion.answers !== undefined &&
                  currQuestion.answers.map(answer => (
                    <Button
                      value={<div dangerouslySetInnerHTML={answer.value} />}
                      style={{ flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                    >
                      <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                    </Button>
                  ))}
              </div>
            </Container>


          ) : <h1>help</h1>}
          </div>
          <Combo>
            <span style={{ fontSize: "50px" }}>{combo}</span>
            <span style={{ fontSize: "20px" }}>COMBO</span>
          </Combo>
        </Body>
      </div>
    </PracticeGame>
  );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url();
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 40px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  font-size: 2em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }


`;

const Question = styled.div`
  background: #E9E9E9;
  user-select: none;
  width: 40em;
  line-height: 35px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 20px 0px 20px;
  `;

const Button = styled.div`
        text-align: center;
        width: 5em;
        line-height: 35px;
        font-size: 3em;
  padding: 35px 0px 35px;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
          font - size: 2.5em;
      }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          margin - bottom: 0;
      }
`;

const Container = styled.div`
      width:100%
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

      const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
  position: realtive;
  top: 35%;
  //left: -15%;
  //width: 100%
  //text-align: center
  font-size 2em;
  //50%
`;

